import { Component, AfterViewInit,OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss'],
})
export class MapsComponent implements OnInit,AfterViewInit {

  map:any;
  @Input() height;
  @Input() get_map_fields;
  @ViewChild('mapElement') mapElement:any = ElementRef;
  @Output() current = new EventEmitter();
  constructor(public db:DataService) { }

  ngOnInit() {
    this.db.located.subscribe(res =>{
         if(res == 'located'){
          this.ngAfterViewInit();
          // console.log(this.db.latitude,this.db.longitude)
         }
       })
  }

  ngAfterViewInit() {
        this.map = new google.maps.Map(this.mapElement.nativeElement, 
          { 
             zoom: 18,
             center: { lat: this.db.location_info.latitude ,lng :this.db.location_info.longitude },
             disableDefaultUI: true,
             clickableIcons: false ,
             draggable:true
        });

        // The marker, positioned at Uluru
        const marker = new google.maps.Marker({
          position: { lat: this.db.location_info.latitude ,lng :this.db.location_info.longitude},
          map: this.map,
          draggable: false,
          visible:false
        });

        this.map.addListener('center_changed', () => {
          let center = this.map.getCenter();
          marker.setPosition(center);
          this.get_map_fields ? this.db.decode(center,'get_map_fields') :  this.db.decode(center,'');

        });

  }


}
